import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPin5 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M4.543 4.508C5.867 2.522 8.19 1 12 1s6.133 1.522 7.457 3.508C20.736 6.426 21 8.65 21 10c0 3.495-1.46 6.338-3.23 8.475-1.764 2.13-3.87 3.604-5.28 4.397a1 1 0 0 1-.98 0c-1.41-.793-3.516-2.266-5.28-4.397C4.46 16.338 3 13.495 3 10c0-1.349.264-3.574 1.543-5.492'
      clipRule='evenodd'
      opacity={0.2}
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M20 10c0-2.5-1-8-8-8s-8 5.5-8 8c0 6.4 5.333 10.5 8 12 2.667-1.5 8-5.6 8-12'
    />
    <path fill='#fff' d='M14.5 9q0 2.5-2.5 2.5T9.5 9 12 6.5 14.5 9' />
  </svg>
)
const ForwardRef = forwardRef(SvgPin5)
export default ForwardRef
